// Select Modal
<template>
  <v-dialog v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title
        :class="store.colors.title"
      >
        <span class="headline">{{ printTitle }}</span>
      </v-card-title>
      <v-card-text class="body-1 text-xs-left">
        <p class="mb-1" v-for="(item, idx) in getMessageItems" :key="idx">{{ item }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="blue darken-2" @click="close">いいえ</v-btn>
        <v-btn flat color="blue darken-2" @click="submit">はい</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DEFAULT = {
  STORE: {
    TITLE: 'ご確認ください',
    MESSAGE: '',
    CALLBACK: null,
    COLORS: JSON.stringify({
      title: 'amber blue-grey--text text--darken-4'
    })
  }
}
export default {
  name: 'util-confirm-modal',
  props: [
    'title', 'message', 'colors'
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      store: {
        title: '',
        message: '',
        callback: null,
        colors: {}
      }
    }
  },
  mounted () {
  },
  methods: {
    init: function (args) {
      this.update(args)
    },
    update: function (args) {
      if ('title' in args) {
        this.$set(this.store, 'title', args.title)
      } else {
        this.$set(this.store, 'title', DEFAULT.STORE.TITLE)
      }
      if ('message' in args) {
        this.$set(this.store, 'message', args.message)
      } else {
        this.$set(this.store, 'message', DEFAULT.STORE.MESSAGE)
      }
      if ('colors' in args) {
        this.$set(this.store, 'colors', args.colors)
      } else {
        this.$set(this.store, 'colors', JSON.parse(DEFAULT.STORE.COLORS))
      }
      if ('callback' in args) {
        this.$set(this.store, 'callback', args.callback)
      } else {
        this.$set(this.store, 'callback', DEFAULT.STORE.CALLBACK)
      }
    },
    open: function (args) {
      this.$set(this.config.status, 'active', true)
      this.init(args)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (typeof this.store.callback === 'function') {
        this.store.callback()
      }
      this.close()
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    printTitle () {
      return this.store.title ? this.store.title : 'ご確認ください'
    },
    getMessageItems () {
      return this.store.message ? this.store.message.split('<br/>') : []
    },
    printMessage () {
      return this.store.message ? this.store.message : ''
    }
  }
}
</script>
